export const BLANK = ' ';
